import { Stack, Typography, useTheme } from "@mui/material";
import type { FC, ReactNode } from "react";

type Props = {
	title: ReactNode;
	actionLabel?: string;
	onAction?: () => void;
	rightAction?: ReactNode;
};

export const SectionLabelRow: FC<Props> = ({
	title,
	actionLabel,
	onAction,
	rightAction,
}) => {
	const theme = useTheme();

	return (
		<Stack
			direction="row"
			alignItems="center"
			justifyContent="space-between"
			px={theme.spacingTokens.lg}
			pt={2.4}
			pb={theme.spacingTokens.sm}
		>
			<Typography variant="overline">{title}</Typography>
			{actionLabel && onAction && (
				<Typography
					component="button"
					variant="button"
					onClick={onAction}
					color={theme.palette.blue[600]}
					border="none"
					px={0}
					py={theme.spacingTokens.xs}
					sx={{
						background: "transparent",
						cursor: "pointer",
						"&:active": { opacity: theme.pressedOpacity },
					}}
				>
					{actionLabel}
				</Typography>
			)}
			{rightAction}
		</Stack>
	);
};
